import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './admingallary.css';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

const AdminGallary = () => {
  const [galImages, setGalImages] = useState([]);
  const url = process.env.REACT_APP_BASE_URL

  // Fetch gallery images
  const fetchGalImages = async () => {
    try {
      const response = await axios.get(url + '/api/gallery/');
      setGalImages(response.data.data);
     
     
    } catch (error) {
      console.error('Error fetching gallery images:', error);
   
    }
  };

  // Call fetchGalImages once when component mounts
  useEffect(() => {
    fetchGalImages();
  }, []);
   
  // Handle image delete logic
  const handleDeleteImage = async (id) => {
    
      try {
        await axios.delete(`${url}/api/gallery/delete/${id}`);
        // Remove the deleted image from the local state without needing to refetch all images
        setGalImages(galImages.filter(image => image._id !== id));
        // console.log("Image deleted successfully");
        toast.success("Image deleted successfully ")
      } catch (error) {
        // console.error('Error deleting image:', error);
       
      }
    
  };


  return (
    <div className="admin-gallery-container">
     <div className='admin-gallary-top'>
     <h1>Admin Gallery Management</h1>
     <Link className='add-button' to="/admin/dashboard/gallery/add-img">Add</Link>
     </div>
      <div className="image-grid-container">
        {galImages.map((image) => (
          <div key={image._id} className="image-item">
             <img src={`${url}/galimg/${image.image}`} alt={image.title} />
             <button onClick={() => handleDeleteImage(image._id)}>Delete</button>
            </div>
        ))}
      </div>
   
    </div>
  );
};

export default AdminGallary;
